'use strict';

/**
 * Show iframe video in modal window
 * @param  {string} videoID Youtube video ID
 * @param {string} linkTitle use link title as iframe title
 */
function showVideo(videoID, linkTitle) {
    const ytHost = window.sYoutubeHost ? window.sYoutubeHost : 'www.youtube-nocookie.com';
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="VideoModal" role="dialog">'
            + '<div class="modal-dialog modal-lg video-dialog"> role="document"'
                + '<!-- Modal content-->'
                + '<div class="modal-content">'
                    + '<div class="modal-header">'
                        + '<button type="button" class="close pull-right" data-dismiss="modal">'
                            + '&times;'
                        + '</button>'
                    + '</div>'
                    + '<div class="modal-body">'
                        + '<div class="video-container">'
                            + '<iframe src="//' + ytHost + '/embed/' + videoID + '?autoplay=1" id="ytplayer" class="iframe-video" type="text/html" frameborder="0" title="' + linkTitle + '"></iframe>'
                        + '</div>'
                    + '</div>'
                    + '<div class="modal-footer"></div>'
                    + '</div>'
                + '</div>'
            + '</div>'
        + '</div>';

    $('body').append(htmlString);

    $('#VideoModal').on('hide.bs.modal', function () {
        $('#VideoModal').remove();
    });
    $('#VideoModal').modal('show');
}

/**
 * Initialize Video functionality
 */
function video() {
    $('body').on('click', '.js-video-link', function (e) {
        var $link = $(this);
        var title = $link.data('iframetitle') || 'Product Video';

        if ($link.data('id')) {
            e.preventDefault();

            showVideo($link.data('id'), title);
        }
    });
}

module.exports = video;
